import MuiButton from "./MuiButton";
import MuiCardActions from "./MuiCardActions";
import MuiCardContent from "./MuiCardContent";
import MuiCardHeader from "./MuiCardHeader";
import MuiIconButton from "./MuiIconButton";
import MuiInputBase from "./MuiInputBase";
import MuiListItemIcon from "./MuiListItemIcon";
import MuiOutlinedInput from "./MuiOutlinedInput";
import MuiPaper from "./MuiPaper";
import MuiTableHead from "./MuiTableHead";
import MuiTableCell from "./MuiTableCell";
import MuiTableRow from "./MuiTableRow";
import MuiTypography from "./MuiTypography";

export default {
  MuiButton,
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiIconButton,
  MuiInputBase,
  MuiListItemIcon,
  MuiOutlinedInput,
  MuiPaper,
  MuiTableHead,
  MuiTableCell,
  MuiTableRow,
  MuiTypography,
};
